import * as React from 'react'
interface DragIndicatorProps {
  className?: string
  color?: string
}
const DragIndicator: React.FC<DragIndicatorProps> = ({ className = '', color = '#137cbd' }) => (
  <svg
    className={`icon--20x20 ${className}`}
    width='20'
    height='20'
    fill='none'
    aria-hidden='true'
    role='img'
    viewBox='0 0 20 20'
  >
    <title>Drag Indicator</title>
    <path fill={color} d='M1,4 H18 V6 H1 V4 M1,9 H18 V11 H1 V7 M3,14 H18 V16 H1 V14' />
  </svg>
)
export default DragIndicator



// WEBPACK FOOTER //
// ./src/components/icons/ui/DragIndicator.tsx